import { AxiosError } from 'axios'

export const linhaComConteudo = (linha: string) => !!linha.replace(/;/g, '').trim()
export const limparCaracteresNaoNumericos = (texto: string) => texto.replace(/\D/g, '')
export function converterDataBrasileira(data: string) {
	const [dia, mes, ano ] = data.split('/')
	return [ano, mes, dia].join('-')
}
export const getRequestErrorMessage = (error: AxiosError<{message: string}>) => {
	if (error.response && error.response.data.message)
		return error.response.data.message

	return error.message
}
